import { Scene } from "../display/Scene";
import { UIComponent } from "./UIComponent";
import { ILaya } from "../../ILaya";
export class View extends Scene {
    static regUI(url, json) {
        ILaya.loader.cacheRes(url, json);
    }
    constructor() {
        super();
        this._watchMap = {};
        this._scene = null;
        this.createChildren();
    }
    createChildren() {
    }
    changeData(key) {
        let arr = this._watchMap[key];
        if (!arr)
            return;
        for (let i = 0, n = arr.length; i < n; i++) {
            let watcher = arr[i];
            watcher.exe(this);
        }
    }
    measureWidth() {
        var max = 0;
        for (var i = this.numChildren - 1; i > -1; i--) {
            var comp = this.getChildAt(i);
            if (comp._visible) {
                max = Math.max(comp._x + comp.width * comp.scaleX, max);
            }
        }
        return max;
    }
    measureHeight() {
        let max = 0;
        for (let i = this.numChildren - 1; i > -1; i--) {
            let comp = this.getChildAt(i);
            if (comp._visible) {
                max = Math.max(comp._y + comp.height * comp.scaleY, max);
            }
        }
        return max;
    }
    set_dataSource(value) {
        this._dataSource = value;
        for (let name in value) {
            let comp = this.getChild(name);
            if (comp instanceof UIComponent)
                comp.dataSource = value[name];
            else if (name in this && !(this[name] instanceof Function))
                this[name] = value[name];
        }
    }
}
View.uiMap = {};
